import { useShallow } from "zustand/react/shallow";

import { useUiStore } from "@stores/uiStore";
import { colors } from "@theme/colors";
import { theme } from "@theme/theme";

import type { IFixedColors, IThemeColors } from "@theme/types";

export const getThemeColor = (name: IThemeColors) => {
  return { ...theme[useUiStore.getState().theme][name], name } as {
    colorKey: keyof typeof colors;
    colorValue: string;
    name: IThemeColors;
  };
};

export const getFixedColor = (name: IFixedColors) => {
  return colors[name];
};

export const getThemeColorUtil = (name: IThemeColors) => {
  const bgClass = `bg-color-${name}`;
  const colorClass = `color-${name}`;
  const borderClass = `border-color-${name}`;

  return { bgClass, colorClass, borderClass };
};

export const getFixColorUtil = (name: IThemeColors) => {
  const bgClass = `bg-color-fix-${name}`;
  const colorClass = `color-fix-${name}`;
  const borderClass = `border-color-fix-${name}`;

  return { bgClass, colorClass, borderClass };
};

export const useThemeColor = (name: IThemeColors) => {
  const themeMode = useUiStore(useShallow((state) => state.theme));

  return theme[themeMode][name];
};
